module.exports = __webpack_public_path__ + "static/media/DD-Bird_walk.37d85633.png";